import AccountNav from "../components/AccountNav";
import { useAuth } from "../context/AuthContext";
import { formatAccountType } from "../utils/userLabels";

export default function AccountProfile() {
  const { user, account_type } = useAuth();

  return (
    <div className="container page account-page">
      <div className="account-shell">
        <AccountNav />

        <section className="account-main">
          <div className="account-hero compact">
            <div>
              <h2>Profile Details</h2>
              <p>View your account information and profile metadata.</p>
            </div>
          </div>

          <div className="account-grid">
            <article className="account-card">
              <h3>Contact Information</h3>
              <div className="account-kv">
                <p>
                  <span>Full Name</span>
                  <strong>{user?.full_name || "-"}</strong>
                </p>
                <p>
                  <span>Email</span>
                  <strong>{user?.email || "-"}</strong>
                </p>
                <p>
                  <span>Account Type</span>
                  <strong className="account-role">{formatAccountType(account_type)}</strong>
                </p>
              </div>
            </article>

            <article className="account-card">
              <h3>Account Preferences</h3>
              <ul className="account-list">
                <li>Preferred contact mode: Email + phone</li>
                <li>Listing alerts: Enabled</li>
                <li>Price trend updates: Weekly digest</li>
                <li>Language: English</li>
              </ul>
            </article>
          </div>
        </section>
      </div>
    </div>
  );
}
